<span class="ms-1">
  <select
    class="form-control change-size-select me-1"
    [(ngModel)]="currentSize"
    [disabled]=disabled
    (change)="onChangeValue()">
    <option *ngFor="let itemSize of sizes" [value]="itemSize.size">{{ itemSize.label }}</option>
  </select>
  {{ label }}
</span>
<ng-container *ngIf="currentSize && currentPage && total">
  <span class="to-right-position">
  <strong>{{ getI1() }}</strong>
    -
    <strong>{{ getI2() }}</strong>
    of
    <strong>{{ total }}</strong>
    items
  </span>
</ng-container>
